import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { REST_API } from 'drapcode-constant';
import * as actions from './redux/actions';
import { getFilteredArray, processData } from '../../common/utils/rest_utils';
import CollectionMappingForm from './CollectionMappingForm';
import CustomLoader from '../common/CustomLoader';
import { apiTypeImages, dynamicSort, snakeCaseToTitleCase } from '../../common/utils/api_utils';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CardTitleHeader from '../../common/ui/CardTitleHeader';

export class CollectionMapping extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionName: '',
    selectedCollection: null,
    selectedMapping: {},
    collectionMapping: [],
  };

  componentDidMount = () => {
    const { externalApiId } = this.props;
    const { externalApiData, collections, inMemoryCollections } = this.props.externalapi;
    if (externalApiId && externalApiData) {
      const { collectionName, collectionMapping } = externalApiData;
      const selectedCollection = [...collections, ...inMemoryCollections].find((collection) => {
        return collection.collectionName === collectionName;
      });
      let mapping = [];
      if (collectionMapping && collectionMapping.length) {
        collectionMapping.map((e, i) => {
          if (e.type === 'collection-field' || e.type === 'derived-field') {
            mapping.push({
              id: i + 1,
              key: e.key,
              value: JSON.stringify({ name: e.value, type: e.type }),
            });
          }
        });
      } else {
        mapping.push({ id: 1, key: '', value: '' });
      }
      this.setState({
        selectedCollectionName: collectionName,
        selectedCollection,
        collectionMapping: mapping,
      });
    } else {
      this.setState({ collectionMapping: [{ id: 1, key: '', value: '' }] });
    }
  };

  processMapping = () => {
    const { collectionMapping, selectedCollectionName } = this.state;
    const collectionMappingArray = getFilteredArray(collectionMapping);
    if (collectionMappingArray.length === 0 && !this.props.methodType === 'DELETE') {
      toast.error(`Please create atleast one mapping`, {});
    } else {
      let collectionMappingObject = [];
      collectionMappingArray.forEach((e) => {
        let selectedValue = JSON.parse(e.value);
        collectionMappingObject.push({
          key: e.key,
          value: selectedValue.name,
          type: selectedValue.type,
        });
      });
      this.props.handleSubmit({ selectedCollectionName, collectionMappingObject });
    }
  };

  createNewCollectionMappingRow = (rowObj) => {
    const collectionMapping = processData(this.state.collectionMapping, rowObj);
    this.setState({ collectionMapping });
  };

  collectionsOptions = () => {
    const { collections, inMemoryCollections } = this.props.externalapi;
    let collectionsToSelect = [];
    if (collections && collections.length > 0) {
      collectionsToSelect = collections.sort(dynamicSort('collectionTitle')).map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }

    let inMemoryCollectionsToSelect = [];
    if (inMemoryCollections && inMemoryCollections.length > 0) {
      inMemoryCollectionsToSelect = inMemoryCollections.map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }

    return [...collectionsToSelect];

    //Uncommect this for In Memory/Percona

    // return [
    //   ...collectionsToSelect,
    //   { label: '-- In Memory Collection --', value: null, disabled: true },
    //   ...inMemoryCollectionsToSelect,
    // ];
  };

  handleCollectionChange = (event) => {
    const { collections, inMemoryCollections } = this.props.externalapi;
    const selectedCollection = [...collections, ...inMemoryCollections].find((collection) => {
      return collection.collectionName === event.target.value;
    });
    this.setState({ selectedCollectionName: event.target.value, selectedCollection });
  };

  showMappingForm = () => {
    const { selectedCollection } = this.state;
    const { externalApiType } = this.props;

    if (selectedCollection) {
      const image = apiTypeImages[externalApiType];
      return (
        <div className="col-12 text-center">
          <div className="row col-12 mx-auto">
            <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
              <div className="border-bottom">
                {externalApiType ? (
                  <img
                    src={require(`../../common/dataSource/img/${image}`)}
                    width="18"
                    height="18"
                    className="no-wh"
                    alt={
                      externalApiType === REST_API
                        ? 'Rest API'
                        : snakeCaseToTitleCase(externalApiType)
                    }
                  />
                ) : (
                  <i className={`wb ${drapcodeIcon(REST_API)}`}></i>
                )}
                &nbsp;
                <b>
                  {externalApiType
                    ? externalApiType === REST_API
                      ? 'Rest API'
                      : snakeCaseToTitleCase(externalApiType)
                    : 'Response'}
                  &nbsp;Fields
                </b>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
              <div className="border-bottom">
                <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;
                <b>Collection Fields</b>
              </div>
            </div>
          </div>
          {this.state.collectionMapping.map((row) => {
            return (
              <CollectionMappingForm
                selectedCollection={selectedCollection}
                key={row.id}
                collectionMappingRow={row}
                createNewCollectionMappingRow={this.createNewCollectionMappingRow}
                externalApiType={externalApiType}
                projectDetail={this.props.projectDetail}
              />
            );
          })}
        </div>
      );
    } else {
      return '';
    }
  };

  render() {
    const { createExternalApiPending, updateExternalApiPending } = this.props.externalapi;
    return (
      <Fragment>
        <div className="card">
          <div className="card-header card-header-text" data-background-color="drapcode-violet">
            <h6 className="card-title pb-0 mb-0 text-capitalise">Collection Mapping</h6>
          </div>
          <div className="card-content">
            <CardTitleHeader />
            <div className="row mx-auto pb-3">
              <div className="form-group col-12">
                <label className="col-3 col-form-label">Choose Collection</label>
                <div className="col-9">
                  <select
                    name="selectedCollectionName"
                    className="form-control form-control-sm custom-select-sm"
                    value={this.state.selectedCollectionName}
                    onChange={this.handleCollectionChange}
                  >
                    <option value="">Select Collection</option>
                    {this.collectionsOptions().map((collection) => (
                      <option key={collection.value} value={collection.value}>
                        {collection.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="row mx-auto pb-3">
              {this.props.methodType && this.props.methodType === 'DELETE'
                ? ''
                : this.showMappingForm()}
            </div>
            <div className="row mx-auto">
              <div className="col-12 text-right">
                <button
                  type="button"
                  className="btn btn-default mr-2"
                  onClick={() => window.history.back()}
                >
                  <i className={`wb ${drapcodeIcon('back')}`}></i>&nbsp;Back
                </button>
                {this.state.selectedCollection ? (
                  <button className="btn btn-theme-submit" onClick={this.processMapping}>
                    <i className={`wb ${drapcodeIcon('save')}`}></i>
                    &nbsp;Save Setting&nbsp;
                    <CustomLoader
                      loading={
                        (createExternalApiPending !== undefined && createExternalApiPending) ||
                        (updateExternalApiPending !== undefined && updateExternalApiPending)
                      }
                    />
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionMapping);
